import { isNonNil, strongValues, type Url, type Uuid } from '@shady-pines/types';
import type { Timestamp } from '@shady-pines/types';
import { isNil, omit } from 'lodash';
import type { AsCreationAttributes, Model } from './model';
import type { User } from './user';

export type EventVenue = Model<{
  id: Uuid<EventVenue>;
  name: string;
  address: string;
  city: string;
  state: string;
  postal_code: string;
  url: Url | null;
  created_by: Uuid<User>;
}>;

export type EventCategory = Model<{
  id: Uuid<EventCategory>;
  name: string;
}>;

export const EventStatus = ['pending', 'approved', 'rejected'] as const;
export type EventStatus = (typeof EventStatus)[number];

export type Event = Model<{
  id: Uuid<Event>;
  title: string;
  description: string;
  start_time: Timestamp;
  end_time: Timestamp;
  venue_id: Uuid<EventVenue> | null;
  active: boolean;
  recurring: boolean;
  featured: boolean;
  status: EventStatus;
  rejection_reason: string | null;
  created_by: Uuid<User>;
}>;

export type EventCategoryMapping = Model<{
  id: Uuid<EventCategoryMapping>;
  event_id: Uuid<Event>;
  category_id: Uuid<EventCategory>;
}>;

export type EventFeaturedUser = Model<{
  id: Uuid<EventFeaturedUser>;
  event_id: Uuid<Event>;
  user_id: Uuid<User>;
}>;

export type PublicEvent = Event & {
  subscriber_count: number;
};

export const editableEventIsCreatable = (
  v?: Partial<Event> | null,
): v is AsCreationAttributes<Event> => {
  if (isNil(v)) {
    return false;
  }
  return strongValues(omit(v, 'venue_id', 'rejection_reason', 'created_by')).every(isNonNil);
};
export const editableVenueIsCreatable = (
  v?: Partial<EventVenue> | null,
): v is AsCreationAttributes<EventVenue> => {
  if (isNil(v)) {
    return false;
  }
  return strongValues(omit(v, 'url', 'created_by')).every(isNonNil);
};
